import { forwardRef } from 'react';
import CreateRubricTable from 'shell/components/CreateRubricTable';
import SubmitRubricTable from 'shell/components/SubmitRubricTable';
import ViewRubricTable from 'shell/components/ViewRubricTable';

const TYPES = ['create', 'submit', 'view'];

export default forwardRef(({ type, ...rest }, ref) => {
    if (!TYPES.includes(type)) throw new Error(`Shell: Invalid type "${type}" in component RubricTable.`);

    if (type === 'create') return <CreateRubricTable ref={ref} {...rest} />;
    if (type === 'submit') return <SubmitRubricTable ref={ref} {...rest} />;
    if (type === 'view') return <ViewRubricTable ref={ref} {...rest} />;
    return <></>;
});
